<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="450"
    >
      <v-card class="loader-card text-center pa-8">
        <div class="loader-icon-wrap mx-auto mb-5">
          <v-progress-circular
            indeterminate
            color="primary"
            size="80"
            width="5"
          >
            <v-icon color="primary" size="32" class="loader-pulse">mdi-cloud-sync-outline</v-icon>
          </v-progress-circular>
        </div>
        <v-card-title class="text-h6 font-weight-bold justify-center pa-0 mb-2">
          Fetching Content&hellip;
        </v-card-title>
        <v-card-text class="pa-0 grey--text text--darken-1">
            <slot></slot>
        </v-card-text>
        <v-progress-linear
          indeterminate
          rounded
          height="6"
          color="primary"
          background-color="#E3E8F4"
          class="mt-6 mb-2"
        ></v-progress-linear>
        <div class="caption grey--text">
          Still working&hellip; {{ elapsed }}s elapsed
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
        name: 'InfoLoader',
        data () {
        return {
            dialog:true,
            elapsed:0,
            timer:null
        }
    },
    mounted () {
        this.timer = setInterval(() => {
            this.elapsed++
        }, 1000)
    },
    beforeDestroy () {
        clearInterval(this.timer)
    },
  }
</script>

<style scoped>
.loader-card {
  border-radius: 20px;
}
.loader-icon-wrap {
  display: inline-flex;
}
@keyframes loader-pulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.18); opacity: 0.6; }
}
.loader-pulse {
  animation: loader-pulse 1.6s ease-in-out infinite;
}
</style>